import React from 'react';
import { motion } from 'framer-motion';
const QUALIFY_IMG = 'https://cdn.magicpatterns.com/uploads/4MdRZb1jhDdm5GHEsX3zn9/vitaly-gariev-FAhkBXFOkDE-unsplash.jpg';
export function Qualify() {
  const programs = ['SNAP / Food Stamps', 'Medicaid', 'WIC', 'SSI', 'Federal Public Housing Assistance', 'Veterans Pension or Survivor Benefits', 'Lifeline Benefit', 'Income-based eligibility'];
  return <section id="qualify" className="flex flex-col md:flex-row min-h-[600px]" data-id="element-151">
      {/* Mobile Image (shows first on mobile) */}
      <div className="md:hidden w-full h-[300px]" data-id="element-152">
        <img src={QUALIFY_IMG} alt="Family using devices" className="w-full h-full object-cover grayscale" data-id="element-153" />
      </div>

      {/* Left Panel - Lime */}
      <div className="w-full md:w-1/2 bg-brand-lime py-16 md:py-24 px-4 sm:px-6 lg:px-16 flex flex-col justify-center relative overflow-hidden" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative z-10" data-id="element-155">
          <p className="text-brand-black font-mono font-bold tracking-widest uppercase text-sm mb-4" data-id="element-156">
            Do You Qualify
          </p>
          <h2 className="text-brand-black text-[44px] md:text-[60px] leading-[0.95] font-display mb-6 uppercase" data-id="element-157">
            See What You Qualify For.
          </h2>
          <p className="text-brand-black/80 text-base md:text-lg mb-8 leading-relaxed font-sans font-medium" data-id="element-158">
            If you or anyone in your household participates in any of the
            following programs, you may be eligible for free or discounted
            services through Prime Nation. Check the list below and take 60
            seconds to confirm.
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10" data-id="element-159">
            {programs.map((program, idx) => <li key={idx} className="border border-brand-black rounded-full px-4 py-3 text-brand-black font-mono text-[13px] uppercase tracking-wider text-center hover:bg-brand-black hover:text-brand-lime transition-colors cursor-default" data-id="element-160">
                {program}
              </li>)}
          </ul>

          <button className="w-full bg-brand-black text-brand-lime px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:bg-white hover:text-brand-black transition-colors min-h-[52px]" data-id="element-161">
            Check My Eligibility
          </button>
        </motion.div>
      </div>

      {/* Right Panel - Image (Desktop) */}
      <div className="hidden md:block w-1/2 relative" data-id="element-162">
        <img src={QUALIFY_IMG} alt="Family using devices" className="absolute inset-0 w-full h-full object-cover grayscale" data-id="element-163" />
        <div className="absolute inset-0 bg-brand-black/20 mix-blend-overlay" data-id="element-164"></div>
      </div>
    </section>;
}